
import { Inject, Injectable } from '@angular/core';

import { KsefRefreshConfigurationStatusCommand, KsefRefreshConfigurationStatusCommandBase } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';

@CommandHandlerFor(KsefRefreshConfigurationStatusCommand)
@Injectable({ providedIn: 'root'})
export class KsefRefreshConfigurationStatusCommandHandler {
	private commandHandler: KsefRefreshConfigurationStatusCommandBase;
	public constructor(
		@Inject(Http) http: HttpService
	) {
		this.commandHandler = new KsefRefreshConfigurationStatusCommandBase(http);
	}

	public async handleAsync(query: KsefRefreshConfigurationStatusCommand): Promise<any> {
		return await this.commandHandler.handleAsync(query);
	}
}
